export const MAX_ACCOUNTS = 30;
/**
 * Feature flag (per-user, evaluated on the home account) that enables decoupled
 * multi-account access. It is the authoritative gate: the backend honors the
 * X-Active-Account-Id header only when this flag is on, and it is surfaced in
 * auth.account.feature_flags via the same per-user evaluation — so the switcher
 * gates the account list on it rather than on membership count alone.
 */
export const DECOUPLE_USERS_FLAG = 'decouple_users';
export const PENDING_SESSION_SWITCH_KEY = 'cio-pending-session-switch';
export const EXPIRED_SESSION_SNACKBAR_KEY = 'cio-expired-session-snackbar';
export const SESSION_METADATA_REFETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes
export const WORKSPACE_MISMATCH_SNACKBAR_KEY = 'cio-workspace-mismatch-snackbar';
